const nl_NL = {
  "colorpicker.opacity-input": "Ondoorzichtigheid",
  "datepicker.clear-date": "Datum legen",
  "datepicker.next-month": "Volgende maand",
  "datepicker.open-calendar": "Kalender openen",
  "datepicker.previous-month": "Vorige maand",
  "input.clear": "Invoer wissen",
  "input.hide-password": "Verberg wachtwoord",
  "input.show-password": "Laat wachtwoord zien",
  "modal.close": "Sluiten",
  "multiselectchips.add-value": "Voeg ‘{value}’ toe",
  "multiselectchips.remove-all": "Verwijder alles",
  "pagination.next-page": "Volgende pagina",
  "pagination.previous-page": "Vorige pagina"
};
export {
  nl_NL as default
};
//# sourceMappingURL=nl_NL.json.js.map
